<template>
  <v-col
    cols="12"
    md="4"
  >
    <v-card class="mt-3">
      <v-row>
        <v-col cols="12">
          <v-card-title class="page-title">
            <v-row>
              <v-col cols="11">
                [{{ booking.bookingId }}]{{ booking.event }}
              </v-col>
              <v-col cols="1">
                <event-status
                  :status="booking.eventStatusId"
                  :size="parseInt('25')"
                />
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-subtitle class="text-no-wrap">
            {{ booking.client }}
          </v-card-subtitle>
          <v-card-text class="d-flex align-center pb-2">
            <div>
              <p class="font-weight-semibold primary--text mb-0">
                <span :inner-html.prop="booking.startDate | datediff(booking.endDate)"></span>
              </p>
              <p>{{ daysToText }}<span v-if="booking.photographer"><br><v-icon>{{ mdiCamera }}</v-icon>{{ booking.photographer }}</span></p>
              <v-btn
                small
                color="primary"
                @click="ViewEvent(booking.bookingKey)"
              >
                Detalle
              </v-btn>
            </div>
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </v-col>
</template>
<script>
import { computed } from '@vue/composition-api'
import moment from 'moment'
import { mdiCamera } from '@mdi/js'
import daysTo from '@/scripts/helpers/daysTo'
import EventStatus from '@/components/statusIcon/EventStatus.vue'

export default {
  components: { EventStatus },
  props: {
    booking: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const daysToText = computed(() => {
      const a = moment.utc(new Date()).local()
      const b = moment(props.booking.startDate)

      return daysTo(b, a)
    })
    const ViewEvent = bookingKey => {
      emit('OnViewEvent', bookingKey)
    }

    return { ViewEvent, daysToText, mdiCamera }
  },
}
</script>
